import { useSelector } from "react-redux";
import { DisplayFromFHIRMarkdown } from "../datatypeComponents/MarkdownEntry";
import { selectAllResources } from "../slices/resourceCollection/resourceCollectionSlice";
import SimpleResourceFieldViewer from "./SimpleResourceFieldViewer";
import { MetadataPatternDisplay } from "./MetadataPatternDisplay";

const ResourceBottomDisplay = ({ fhirJson }) => {

    const resourceCollection = useSelector(state => selectAllResources(state));

    if (!fhirJson) {
        return <></>
    }

    let howToCite;
    if (fhirJson.citeAs) {
        howToCite = fhirJson.citeAs;
    } else if (fhirJson.extension?.length) {
        for (const extension of fhirJson.extension) {
            if (extension.url === "http://hl7.org/fhir/StructureDefinition/artifact-citeAs" &&
                extension.valueMarkdown) {
                howToCite = extension.valueMarkdown;
                break;
            }
        }
    }

    return <div>
        <h3 id="how-to-cite">How to Cite</h3>
        <div style={{ marginLeft: "24px" }}>
            {(howToCite) ?
                <div>
                    <p><b>Citation Summary:</b></p>
                    <DisplayFromFHIRMarkdown markdown={howToCite} />
                </div>
                :
                <p>Can be added upon editing.</p>
            }
        </div>
        <h3 id="metadata">Metadata</h3>
        <div style={{ marginLeft: "24px" }}>
            <MetadataPatternDisplay fhirJson={fhirJson} />
        </div>
        <h3 id="associated-resources">Associated Resources</h3>
        <div style={{ marginLeft: "24px" }}>
            {resourceCollection?.length > 1 ? <>
                <div style={{ textAlign: "left" }}>
                    {resourceCollection.map((entry, index) => {
                        const url = "https://fevir.net/resources/" + entry.resourceType + "/" + entry.id;
                        return <div key={index}>
                            {index === 0 ?
                                <p>Resources referenced by <a href={url} target='_blank' rel='noopener noreferrer'>
                                    <b>{entry.resourceType}: </b>{entry.displayTitle} (FOI {entry.id})
                                </a> include:</p>
                                :
                                <a href={url} target='_blank' rel='noopener noreferrer'>
                                    <b>{entry.resourceType}: </b>{entry.displayTitle} (FOI {entry.id})
                                </a>}
                        </div>
                    })}
                </div>
            </>
                :
                <p>No referenced Resources.</p>}
        </div>
        <h3 id="json-outline">JSON Outline</h3>
        <SimpleResourceFieldViewer resource={fhirJson} parentElement={""} />
        <br /><br />

    </div>
}

export default ResourceBottomDisplay;